/* import __COLOCATED_TEMPLATE__ from './paragraph-button-image.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();